import { Injectable } from '@angular/core';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private get ls(): Storage {
    return localStorage;
  }

get(key: string): string | null;
get<T>(key: string): T | null;
get<T>(key: string): T | null {
    this.consolelsError(key);
    
    const raw = this.ls?.getItem(localStorageAccessConstant[key]);
    if (raw == null) {
        this.consolelsError(key);
        return null;
    }
      try {
          return JSON.parse(raw) as T;
      } catch {
          return raw as T;
      }
  }
  
  set<T>(key: string, value: T): void {
    this.consolelsError(key);
    this.ls?.setItem(localStorageAccessConstant[key], JSON.stringify(value));
  }

  remove(key: string): void {
    this.ls?.removeItem(localStorageAccessConstant[key]);
    this.consolelsError(key);
  }
  private consolelsError(key: string): void{
    if (!(key in localStorageAccessConstant)) {
      console.warn(`Key "${key}" not founnd in storage.`);
    }
  }
}
